import React, { useEffect, useState } from "react";
import {
  changeStatusService,
  getRepresentativeStatus,
} from "../../../services/RepresentativeService";

const RepresentativeStatus = () => {
  const user = JSON.parse(sessionStorage.getItem("userDetails"))?.result;
  const [representativeStatus, setRepresentativeStatus] = useState(false);

  useEffect(() => {
    repStatus();
  }, [representativeStatus]);

  const repStatus = () => {
    getRepresentativeStatus(user?.user?.id).then((res) => {
      const response = res.data?.result;
      setRepresentativeStatus(response?.status);
    });
  };

  const changeStatus = (status) => {
    const statusValue = status === "true" ? true : false;
    changeStatusService(user?.user?.id, statusValue).then((res) => {
      setRepresentativeStatus(statusValue);
    });
  };
  return (
    <select
      className="form-select w-25"
      value={representativeStatus}
      onChange={(e) => changeStatus(e.target.value)}
      style={{
        color: representativeStatus === true ? "green" : "red",
      }}
    >
      <option value="true" style={{ color: "green" }}>
        Available
      </option>
      <option value="false" style={{ color: "red" }}>
        Busy
      </option>
    </select>
  );
};

export default RepresentativeStatus;
